module.exports = __webpack_public_path__ + "img/partners.6a9109d1.png";